export enum OnboardingFlowType {
  OwnSensor = 'own_sensor',
  Purchase = 'purchase',
  PurchaseStelo = 'purchase_stelo',
  ReferralVideoCall = 'referral_video_call',
}
